import SnackbarNotification from '@/store/modules/snackbarNotification/constants';

let COUNTER = 0;

export default {
  [SnackbarNotification.mutationTypes.add](state, message) {
    const localState = state;
    const localMessage = message;

    COUNTER += 1;

    localMessage.id = message.id || COUNTER;

    localState.stack.push(localMessage);
  },

  [SnackbarNotification.mutationTypes.remove](state, message) {
    const localState = state;

    localState.stack = state.stack.filter((m) => m !== message);
  },
};
